import { FcConferenceCall, FcAcceptDatabase, FcPanorama, FcIdea } from "react-icons/fc"


export const ChooseUsdata = [
    {
        "icon": <FcConferenceCall />,
        "title": "Certified Team",
        "desc": "You get a certified management team to not just work but conduct due research and tests before implementing & getting your job done.",
    },
    {
        "icon": <FcAcceptDatabase />,
        "title": "Privacy/Highly Secured",
        "desc": "Security/Privacy is very vital! We do not joke with that and that is why all our software pass a rigorous security process to make sure your business is safe. ",
    },
    {
        "icon": <FcPanorama />,
        "title": "Modern Design",
        "desc": "We do just deliver on time but use the latest tech tools to implement a professionally crafted design from the desk of our in-house UI/UX Designers.",
    },
    {
        "icon": <FcIdea />,
        "title": "24/7 Support",
        "desc": "Working with Bexil Group gets you a free Support. Our support team are available 24/7 to happily render support to you.",
    }
]